import Loading from '../../Common/Loading';
import { useFinancingChartsDataContext } from './hooks/useFinancingChartsDataContext';
import { FinancingBySource } from './FinancingBySource';
import { FinancingSourceByYear } from './FinancingSourceByYear';
import { FinancingByChargingReason } from './FinancingByChargingReason';
import { FinancingNatureBySource } from './FinancingNatureBySource';

export const Charts = () => {
    const { isLoading } = useFinancingChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <FinancingSourceByYear />
                <FinancingByChargingReason />
            </div>
            <div className="charts-side-by-side-dashboards">
                <FinancingBySource />
                <FinancingNatureBySource />
            </div>
        </>
    );
};
